import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getDemandes = () => api.get('/demandes');
export const getDemande = (id) => api.get(`/demandes/${id}`);
export const getDemandeMessages = (id) => api.get(`/demandes/${id}/messages`);
export const updateDemandeStatus = (id, status) => api.put(`/demandes/${id}/status`, { status });

export const getDiscussions = () => api.get('/discussions');
export const getDiscussionMessages = (id) => api.get(`/discussions/${id}/messages`);
export const sendDiscussionMessage = (id, employeId, contenu) => 
  api.post(`/discussions/${id}/messages`, { employe_id: employeId, contenu });

export const getStats = () => api.get('/stats');
export const getEmployes = () => api.get('/employes');

export default api;

